import { useState } from "react";
import moment from "moment";
import { createUUId } from "../utils/uuid";

const useFollowUpsList = () => {
    const [followUpList, setFollowUpList] = useState([]);
    const [deletedFollowUpIds, setDeletedFollowUpIds] = useState([]);

    const addFollowUp = () => {
        setFollowUpList([
            ...followUpList,
            {
                id: null,
                uuid: createUUId(),
                followUpTpyeId: null,
                comments: "",
                creationDate: moment.now(),
                new: true,
                isHide: true,
                hasActivityQuestions: false,
            },
        ]);
    };

    const updateFollowUp = (updatedFollowUp) => {
        setFollowUpList((prevList) =>
            prevList.map((followup) => (followup.uuid === updatedFollowUp.uuid ? { ...followup, ...updatedFollowUp } : followup)),
        );
    };

    const deleteFollowUp = (followUpUuid) => {
        setFollowUpList((prevList) => {
            const followUpToDelete = prevList.find((followUp) => followUp.uuid === followUpUuid);
            const updatedList = prevList.filter((followUp) => followUp.uuid !== followUpUuid);

            if (followUpToDelete && !followUpToDelete.new && followUpToDelete.id) {
                setDeletedFollowUpIds((prevIds) => [...prevIds, followUpToDelete.id]);
            }
            return updatedList;
        });
    };

    const popFollowup = () => {
        setFollowUpList((prevList) => {
            if (prevList.length === 0) {
                return prevList;
            }
            const updatedList = prevList.slice(0, prevList.length - 1);
            return updatedList;
        });
    };

    const resetFollowups = () => setFollowUpList([]);

    return {
        followUpList,
        addFollowUp,
        updateFollowUp,
        deleteFollowUp,
        deletedFollowUpIds,
        popFollowup,
        resetFollowups,
    };
};

export default useFollowUpsList;
